<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="400">
    <v-card class="pa-5">
      <p class="title custom-pink--text">Edit Name</p>
      <input v-show="false" type="file" ref="avatar" @input="onFilePicked" />
      <v-avatar
        :class="{ hover: item.image }"
        class="d-flex mx-auto mb-6"
        size="120"
        @click="onImageClick"
      >
        <v-img :src="img || item.image">
          <template #placeholder>
            <v-row
              style="height: 120px; background-color: lightgray"
              align="center"
              justify="center"
            >
              <span class="title">{{ item.name }}</span>
            </v-row>
          </template>
        </v-img>
      </v-avatar>
      <v-text-field dense v-model="crud.name" outlined />
      <v-btn class="text-capitalize d-flex ml-auto" color="#FF347C" outlined @click="onSave"
        >Save</v-btn
      >
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    value: Boolean,
    item: {
      required: true,
      type: Object,
    },
    patch: {
      required: true,
      type: Function,
    },
  },
  data() {
    return {
      crud: {
        name: "",
        image: "",
      },
      img: "",
    };
  },
  methods: {
    async onSave() {
      let newItem = {
        uuid: this.item.uuid,
        ...this.crud,
      };
      const response = await this.patch(newItem);
      if (response) {
        this.$emit("itemUpdated", response.data);
      }
    },
    create() {
      this.crud.name = this.item.name;
      this.crud.image = "";
      this.img = "";
    },
    onFilePicked(e) {
      try {
        const [files] = e.target.files;
        if (files !== undefined) {
          const fileName = files.name;
          if (fileName.lastIndexOf(".") <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(files);
          fr.addEventListener("load", () => {
            this.crud.image = files;
            this.img = fr.result;
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    onImageClick() {
      if (this.item.image) {
        this.$refs.avatar.click();
      }
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.create();
      }
    },
  },
  created() {
    this.create();
  },
};
</script>
<style scoped>
.custom-pink--text {
  color: #ff347c;
}
</style>
